import { useEffect, useState } from "react";
import sequenceApis from "../api/master/sequence";

export const MODULE_MAP: Record<number, string> = {
    157: "Site",
    158: "User",
    159: "Supplier",
    160: "Department",
    161: "Role",
    162: "Site Break Down Structure",
    163: "Location",
    164: "Sequence",
    165: "Address",
    166: "General Contractor",
    167: "Material",
    168: "UOM",
    169: "Brand",
    170: "Work Category",
    171: "Labour",
    172: "Tools & Machinery",
    173: "Tax",
    174: "Cost Center",
    175: "General Ledger",
    177: "Clients",
    178: "Work Uom",
    179: "Gate Entry",
    49: "Handover"
};

export default function useSequence(moduleId: number) {
    const [hasSequence, setHasSequence] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchSequence = async () => {
        try {
            const res = await sequenceApis.fetchSequenceByModuleId(moduleId);
            setHasSequence(Array.isArray(res?.data) && res.data.length > 0);
        } catch (err) {
            console.error("Sequence API error", err);
            setHasSequence(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSequence();
    }, [moduleId]);

    return {
        hasSequence,
        loading,
        moduleName: MODULE_MAP[moduleId],
        refetch: fetchSequence,
    };
}
